import type React from 'react';
import { useState } from 'react';

import { useScreen } from '../useScreen';

export interface EnterProductCategoryViewProps {
    categoryIds: string[];
    setCategoryIds: React.Dispatch<React.SetStateAction<string[]>>;
    onSubmit: () => void;
}

const useEnterProductCategory = (props: { wizard_id: string }): EnterProductCategoryViewProps => {
    const { store, updateWizardData, onSubmit: navigateToNextStep } = useScreen(props.wizard_id);
    const [categoryIds, setCategoryIds] = useState<string[]>(store?.data.productCategoryIds ?? []);

    const onSubmit = () => {
        updateWizardData({
            productCategoryIds: categoryIds
        });
        navigateToNextStep();
    };

    return {
        categoryIds,
        setCategoryIds,
        onSubmit
    };
};

export default useEnterProductCategory;
